export default function MenuBarCtrl($scope, UserService, $mdSidenav, $state, $mdMedia, $wamp, $localstorage) {
  $scope.user = UserService;
  $scope.go = $state.go;
  $scope.$mdMedia = $mdMedia;

  $scope.toggleMenu = function () {
    $mdSidenav('left').toggle();
  };

  $scope.accounts = [];

  UserService.subject
    .take(1)
    .safeApply($scope, function (u) {
      const ecitoken = $localstorage.get('masqtoken') || $localstorage.get('ecitoken');
      $wamp.call('poser.get_assumable_logins', [ecitoken]).then((res) => {
        $scope.accounts = res;
      });
    }).subscribe();

  $scope.switchUser = function (id) {
    const ecitoken = $localstorage.get('masqtoken') || $localstorage.get('ecitoken');
    $wamp.call('poser.pose_as', [ecitoken, id]).then(res => {

      if ($localstorage.get('masqtoken')) {
        $localstorage.set('masqtoken', res.newJwt);
      } else {
        $localstorage.set('ecitoken', res.newJwt);
      }

      location.reload();
    });
  };
}
